module.exports = __webpack_public_path__ + "static/img/lotus.ebe9951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/lotus.jpg
// module id = 3qir
// module chunks = 1